import Service, { service } from '@ember/service';

export default class MessagingLoggingService extends Service {
  @service intl;
  @service messaging;

  trackEvent(intlKey, additionalProperties = {}) {
    const intlAction = this.intl.t(`${intlKey}.action`);
    const intlObject = this.intl.t(`${intlKey}.object`);
    const eventName = `${intlObject} ${intlAction}`;
    this.messaging.trackEvent(eventName, {
      ...additionalProperties,
      action: intlAction,
      object: intlObject,
    });
  }
}
